import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_7297_89131)\"><path d=\"M18.6875 1H3.0625C2.19956 1 1.5 1.69956 1.5 2.5625V18.1875C1.5 19.0505 2.19956 19.75 3.0625 19.75H18.6875C19.5505 19.75 20.25 19.0505 20.25 18.1875V2.5625C20.25 1.69956 19.5505 1 18.6875 1Z\" stroke=\"white\" stroke-width=\"2.08333\" stroke-linejoin=\"round\"></path><path d=\"M5.66699 12.458L9.83366 8.29134L11.917 11.9372L16.0837 7.77051\" stroke=\"white\" stroke-width=\"2.08333\" stroke-linejoin=\"round\"></path></g><defs><clipPath id=\"clip0_7297_89131\"><rect width=\"21\" height=\"21\" fill=\"white\" transform=\"translate(0.5)\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }